<template>
    <v-container>
        <draggable v-model="computedItems" tag="div" handle=".cursor">
            <transition-group name="slide-x-transition" mode="out-in" tag="v-row" class="row">
                <v-col :cols="12" v-for="(option, index) in computedItems" :key="option.id">
                    <v-card tile :key="`option-${option.id}`">
                        <v-toolbar flat dark dense color="secondary">
                            <v-toolbar-title class="text-body-2">{{ `${$t('Option')}-${index + 1}` }}</v-toolbar-title>
                            <v-spacer />
                            <v-btn icon @click="remove(option)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-row align="center" justify="center">
                                <v-col>
                                    <v-textarea
                                        :value="option.text"
                                        @input="handleInput(option, 'text', $event)"
                                        no-resize
                                        :label="$t('Lösung')"
                                        outlined
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="auto">
                                    <v-icon class="cursor">mdi-cursor-move</v-icon>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </transition-group>
        </draggable>
    </v-container>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'fill-blank',
    components: {
        draggable
    },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        computedItems: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        remove(option) {
            this.$emit(
                'input',
                this.value.filter((item) => option !== item)
            );
        },
        handleInput(option, key, value) {
            this.$emit(
                'input',
                this.value.map((item) => {
                    if (item === option) {
                        let copy = { ...item, [key]: value };
                        return copy;
                    }
                    return item;
                })
            );
        }
    },
    activated() {
        this.$emit('input', [
            {
                id: parseInt(performance.now()).toString(),
                text: '',
                isAnswer: true,
                minimum: 0,
                maximum: 100,
                steps: 1,
                sequenceNo: 1,
                mediaId: '',
                fileURL: '',
                fileName: '',
                fileType: '',
                size: 0,
                answeredOrder: 0
            }
        ]);
    }
};
</script>

<style scoped>
.cursor {
    cursor: move;
}
</style>
